<template>
    <v-container>
        <page-header :title="`${mode === 'edit' ? 'Edit' : mode === 'show' ? '' : 'New'} Staff member`.trim()" icon="mdi-account-tie-outline" />
        <v-card class="form-card" elevation="1">
            <v-form :readonly="readOnly">
                <div class="form-section-title">
                    <v-icon small>mdi-card-account-details-outline</v-icon>Details
                </div>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="staff.name"
                            outlined
                            dense
                            hide-details="auto"
                            label="Name"
                            :rules="rules"
                            :clearable="clearable"
                        />
                    </v-col>
                </v-row>

                <div class="form-section-title">
                    <v-icon small>mdi-cash-multiple</v-icon>Payment per season
                </div>
                <div class="text-caption grey--text text--darken-1 mb-3">
                    <b>Per match:</b> filled in automatically when the member is added to a match of that season (it can still be changed there).
                    <b>Monthly:</b> a fixed salary for the months of the season; the member's matches then cost nothing extra.
                </div>
                <amount-rows
                    v-model="staff.seasonPayments"
                    :items="seasons"
                    :item-text="seasonLabel"
                    key-field="seasonId"
                    label-field="seasonName"
                    amount-field="paymentPerMatch"
                    mode-field="monthly"
                    :modes="paymentModes"
                    select-label="Season"
                    add-label="Add season"
                    empty-text="No payment set for any season yet."
                    icon="mdi-calendar"
                    :readonly="readOnly"
                />
            </v-form>
        </v-card>
        <div v-if="mode !== 'show'" class="form-actions">
            <v-spacer />
            <v-btn large text @click="$router.go(-1)">
                Cancel
            </v-btn>
            <v-btn :loading="loading" :disabled="shouldDisableSubmit()" class="white--text" large depressed color="black" @click="onSubmit">
                <v-icon left>mdi-content-save-outline</v-icon>Save
            </v-btn>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import PageHeader from '@/components/PageHeader'
    import Alert from '@/components/Alert'
    import AmountRows from '@/components/AmountRows'
    import staffService from '@/services/staff'
    import seasonService from '@/services/season'
    import { seasonLabel, sortSeasons } from '@/utils/season'

    export default {
        name: 'StaffForm',
        components: { Alert, AmountRows, PageHeader },
        data: () => {
            return {
                showAlert: false,
                message: null,
                type: null,
                mode: null,
                readOnly: false,
                clearable: true,
                loading: false,
                staffId: null,
                staff: {
                    name: '',
                    seasonPayments: []
                },
                seasons: [],
                paymentModes: [
                    { value: false, text: 'Per match', amountField: 'paymentPerMatch', amountLabel: 'Per match' },
                    { value: true, text: 'Monthly', amountField: 'monthlySalary', amountLabel: 'Monthly salary' }
                ],
                rules: [
                    v => !!v || 'Field is required'
                ]
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            seasonService.getSeasons().then(resp => {
                this.seasons = sortSeasons(resp.data.content)
            })
            this.staffId = this.$route.params.staffId
            if (this.staffId) {
                staffService.getStaff(this.staffId).then(resp => {
                    this.staff = { ...resp.data, seasonPayments: resp.data.seasonPayments || [] }
                })
            }
        },
        methods: {
            seasonLabel,
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            shouldDisableSubmit() {
                const missing = value => value === null || value === undefined || value === '' || value < 0
                const incomplete = this.staff.seasonPayments.some(row => !row.seasonId || missing(row.monthly ? row.monthlySalary : row.paymentPerMatch))
                return !this.staff.name || incomplete
            },
            onSubmit() {
                this.loading = true
                // a monthly member costs nothing per match
                const staff = {
                    ...this.staff,
                    seasonPayments: this.staff.seasonPayments.map(row => ({
                        ...row,
                        monthly: !!row.monthly,
                        paymentPerMatch: row.monthly ? 0 : row.paymentPerMatch,
                        monthlySalary: row.monthly ? row.monthlySalary : null
                    }))
                }
                const request = this.mode === 'edit'
                    ? staffService.updateStaff(this.staffId, staff)
                    : staffService.createStaff(staff)
                request.then(() => {
                    this.loading = false
                    this.$router.push('/staff')
                }).catch(error => {
                    this.loading = false
                    this.setAlert((error.response && error.response.data && error.response.data.message) || 'Could not save', 'error')
                })
            }
        }
    }
</script>
